module.exports = __webpack_public_path__ + "static/media/download-file.66c92e40.svg";